import {RootState} from '../../../setup'
import {FC} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {IWorkspaceState} from '../../@reducer/WorkspaceRedux'
import {StripHtml} from '../../features'
import {AnnouncementHomepage1} from '../../@types'

export const Announcement: FC<{announcement: AnnouncementHomepage1}> = ({announcement}) => {
    const {
        colors: {
            primary,
            secondary,
        },
    } = useSelector<RootState>(({workspace}) => workspace, shallowEqual) as IWorkspaceState


    return (
        <div className="row my-5">
            <div className="col-12">
                {/*begin::Engage widget*/}
                <div className="card h-lg-100"
                     style={{background: `linear-gradient(112.14deg, ${primary} 0%, ${secondary} 100%)`}}
                >
                    {/*begin::body*/}
                    {
                        announcement
                            ? (
                                <div className="card-body p-5 p-md-7">
                                    <div className="row align-items-center">
                                        <div className="col-12 col-sm-8">
                                            <div
                                                className="d-flex justify-content-between h-100 flex-column pt-xl-5 pb-xl-2 ps-xl-7">
                                                {/*begin::Container*/}
                                                <div className="mb-7">
                                                    <div className="mb-6">
                                                        <h3 className="fs-2x fw-semibold text-white">{announcement.title}</h3>
                                                        <span
                                                            className="fw-semibold text-white opacity-75">{StripHtml(announcement.text)}</span>
                                                    </div>
                                                    {/*begin::Items*/}
                                                    <div className="d-flex align-items-center flex-wrap d-grid gap-2">
                                                        {
                                                            announcement.icon.map((item, index) => (
                                                                <div className="d-flex align-items-center me-5 me-xl-13"
                                                                     key={index}>
                                                                    <div className="symbol symbol-30px symbol-circle me-3">
                                                                        <div className="symbol-label"
                                                                             style={{background: 'rgba(255, 255, 255, 0.15)'}}
                                                                        >
                                                                            <img src={`${item.src}`} className="w-20px" alt="" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="m-0">
                                                                        <a href="#"
                                                                           className="text-white opacity-75 fs-8">{item.title}</a>
                                                                        <span
                                                                            className="fw-bold text-white fs-7 d-block">{item.text}</span>
                                                                    </div>
                                                                </div>

                                                            ))
                                                        }
                                                    </div>
                                                    {/*end::Items*/}

                                                </div>
                                                {/*end::Container*/}
                                                {/*begin::Action*/}
                                                <div className="m-0">
                                                    <a href={announcement.button.href || '#' } target="_blank"
                                                       className="btn btn-color-white bg-white bg-opacity-15 bg-hover-opacity-25 fw-semibold"
                                                    >
                                                        {announcement.button.title}
                                                    </a>
                                                </div>
                                                {/*end::Action*/}
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-4 d-flex justify-content-end">
                                            <img src={`${announcement.image}`}
                                                 alt=""
                                                 className="w-200px w-md-300px" />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )
                    }
                    {/*begin::body*/}
                </div>
                {/*end::Engage widget*/}
            </div>
        </div>
    )
}